import { createWebHistory, createRouter } from 'vue-router'

import GoogleForm from './components/GoogleForm.vue'
import SwedenForm from './components/SwedenForm.vue'

const routes = [
    {
        path: '/',
        component: GoogleForm,
        meta: {
            title: 'Part-Time Job | TruMatrix AI is Hiring Remote Music Reviewers',
            metaTags: [
                { name: 'description', content: 'Part-Time Job | TruMatrix AI is Hiring Remote Music Reviewers' },
                { name: 'keywords', content: 'Part-Time Job,work from home jobs,work from home,work from home jobs no experience,online part-time jobs' }, 
                { property: 'og:title', content: 'Part-Time Job | TruMatrix AI is Hiring Remote Music Reviewers' }
            ]
        }
    },
    {
        path: '/sweden',
        component: SwedenForm,
        meta: {
            title: 'Deltidsjobb hemma|Rekrytering av externa restaurangrecensenter',
            metaTags: [
                { name: 'description', content: 'Deltidsjobb hemma|Rekrytering av externa restaurangrecensenter' },
                { name: 'keywords', content: 'Deltidsjobb hemma,jobba hemifrån Jobb,jobba hemifrån,jobb hemifrån jobb ingen erfarenhet,Online deltidsjobb' }, 
                { property: 'og:title', content: 'Deltidsjobb hemma|Rekrytering av externa restaurangrecensenter' }
            ]
        },
    },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router